import "./styles/App.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import HomePage from "./pages/HomePage/HomePage";
import Quiz from "./pages/Quiz/Quiz";
import Results from "./pages/Results/Results";
import MyFinds from "./pages/MyFinds/MyFinds";
import Login from "./pages/Auth/Login";
import Signup from "./pages/Auth/Signup";
import NotFound from "./pages/NotFound/NotFound";

// Served under /classifind on madisonmarino.com; empty basename in dev.
const basename = process.env.PUBLIC_URL || "/";

function App() {
  return (
    <BrowserRouter basename={basename}>
      <ScrollToTop />
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/quiz/results/:artist/:id" element={<Results />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/finds"
              element={
                <ProtectedRoute>
                  <MyFinds />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
